import React from 'react';
import { BadgeCheck, Star } from 'lucide-react';
import { PARTNER_CATEGORY_LABELS } from '../copy';

const initials = (name) => (name || '')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part[0].toUpperCase())
  .join('');

// Partner Recommendation (PRD §6.6, Phase 2): the "who" behind a need. The
// need first, then one partner, why they fit, and the standing disclosure
// that partners are paid members of the network and matching is fee-blind.
export default function PartnerRecommendationBody({ data }) {
  const partner = data.partner || {};
  const why = Array.isArray(data.why) ? data.why : [];

  return (
    <div className="flex flex-col gap-5">
      {data.need && <p className="m-0 text-[15px] leading-[1.6] text-foreground/[0.88]">{data.need}</p>}
      <div className="flex items-start gap-3.5">
        {partner.avatar_url ? (
          <img src={partner.avatar_url} alt="" className="w-12 h-12 rounded-full object-cover shrink-0" />
        ) : (
          <span className="w-12 h-12 rounded-full shrink-0 inline-flex items-center justify-center bg-succeedo-orange/10 text-orange-ink text-[15px] font-medium">
            {initials(partner.name)}
          </span>
        )}
        <div className="flex flex-col gap-1 min-w-0">
          <span className="inline-flex items-center gap-1.5 text-[17px] font-medium text-foreground">
            {partner.name}
            {partner.verified && <BadgeCheck size={16} className="text-teal-ink" aria-label="Verified" />}
          </span>
          <span className="text-[13px] text-muted-foreground">
            {[PARTNER_CATEGORY_LABELS[partner.category] || partner.category, partner.org_name].filter(Boolean).join(' · ')}
          </span>
          {partner.rating ? (
            <span className="inline-flex items-center gap-1 text-[12px] text-muted-foreground tabular-nums">
              <Star size={12} /> {partner.rating} · {partner.review_count} reviews
            </span>
          ) : null}
        </div>
      </div>
      {why.length > 0 && (
        <div className="flex flex-col gap-2">
          <span className="font-label text-[10px] uppercase tracking-[0.06em] text-muted-foreground">
            Why {partner.name ? partner.name.split(' ')[0] : 'them'}
          </span>
          <ul className="m-0 p-0 list-none flex flex-wrap gap-1.5">
            {why.map((reason) => (
              <li key={reason} className="text-[12px] py-1 px-2.5 rounded-full border border-border text-foreground/80">
                {reason}
              </li>
            ))}
          </ul>
        </div>
      )}
      {data.disclosure && (
        <p className="m-0 text-[12px] leading-normal text-muted-foreground" data-testid="partner-disclosure">
          {data.disclosure}
        </p>
      )}
    </div>
  );
}
